

import React from "react";
import logo from "../imgs/photBlogo.png"

const NavBar = ()=>{
    return (
        <div className="logobar">
            <img className="logo" src={logo} alt="logo"/>
        </div>
    )
}

export default NavBar